export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-arrows-out-901f21616a9fa286a2f103f6388deac2.svg";